const React = require('react');
const AjaxFunctions = require('./ajaxFunctions.js');
const Link = require('react-router-dom').Link;
const OneLineTextField = require('./components/commonControls.jsx').OneLineTextField;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const SharedModels = require('../../../shared/sharedModels');
const Utils = require('./utils.js');
const Toastr = require('toastr');
const ToastAlert = require('./components/toastAlert');

import Select from 'react-select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormControl from '@material-ui/core/FormControl';
import Button from "@material-ui/core/Button/Button";
import Checkbox from '@material-ui/core/Checkbox';
import UserDetails from './components/userDetails.jsx';
import { Grid, Card, CardContent, CardHeader, Typography, CardActions, LinearProgress, Tabs, Tab } from '@material-ui/core';
import { useState, useEffect } from 'react';

function GeneralInformation(props) {
   let [saving, setSaving] = useState(false);
   let [bio, setBio] = useState(props.user.bio || '');
   let [link, setLink] = useState(props.user.link || '');
   let [location, setLocation] = useState(props.user.location || '');
   let [affiliation, setAffiliation] = useState(props.user.affiliation || '');
   let [orcidID, setOrcidID] = useState(props.user.orcidID || '');
   let [interest, setInterest] = useState(props.interests || []);
   let [expertise, setExpertise] = useState(props.expertise || []);
   let [avatar, setAvatar] = useState(null)
   let saveProfile = async () => {
      setSaving(true)
      try {
         if(affiliation.trim().length == 0) {
            throw new Error("Users are required to have an affiliation.");
         }
         if(expertise.length == 0) {
            throw new Error("Users are required to have at least 1 expertise.");
         }
         let userProfile = new SharedModels.User({ bio, link, location, affiliation, interest, expertise, orcidID });
         await AjaxFunctions.setUserProfile(userProfile);
         await AjaxFunctions.setUserExpertise(expertise.map(expertise => expertise.value));
         await AjaxFunctions.setUserInterests(interest.map(interest => interest.value));
         if (avatar) await AjaxFunctions.uploadAvatar(avatar);
         let idUser = window.globals.idUser || Utils.getParameterByName('idUser', window.location.href);
         let profileData = await AjaxFunctions.getProfileData(idUser);
         ReduxStore.store.dispatch(ReduxStore.UserFunctions.setTargetUser(profileData.userData));
         ToastAlert.success('Changes Saved.');
         setSaving(false);
      } catch (err) {
         ToastAlert.error(err.message || 'Error updating profile.');
         setSaving(false)
      }
   }
   return (<Card style={{ marginBottom: '1em' }}>
      {saving && <LinearProgress />}
      <CardContent>
         <Typography>Bio</Typography>
         <OneLineTextField
            data={bio}
            isEditing={true}
            onChange={(e) => setBio(e.target.value)}
            dataField='bio'
            checkForValidationErrors={false}
            placeholder={'Short Bio'}
            maxLength={100}
            disableMargin
         />
         <br/>
         <br/>
         <Typography>Link</Typography>
         <OneLineTextField
            data={link}
            isEditing={true}
            onChange={(e) => setLink(e.target.value)}
            dataField='link'
            checkForValidationErrors={false}
            placeholder={'Link'}
            maxLength={100}
            disableMargin
         />
         <br/>
         <br/>
         <Typography>Location</Typography>
         <OneLineTextField
            data={location}
            isEditing={true}
            onChange={(e) => setLocation(e.target.value)}
            dataField='location'
            checkForValidationErrors={false}
            placeholder={'Location'}
            maxLength={100}
            disableMargin
         />
         <br/>
         <br/>
         <Typography>Affiliation</Typography>
         <OneLineTextField
            data={affiliation}
            isEditing={true}
            onChange={(e) => setAffiliation(e.target.value)}
            dataField='affiliation'
            checkForValidationErrors={false}
            placeholder={'Affiliation'}
            maxLength={100}
            disableMargin
         />
         <br/>
         <br/>
         <Typography>ORCID ID</Typography>
         <OneLineTextField
            data={orcidID}
            isEditing={true}
            onChange={(e) => setOrcidID(e.target.value)}
            dataField='orcidID'
            checkForValidationErrors={false}
            placeholder={'ORCID ID'}
            maxLength={100}
            disableMargin
         />
         <br/>
         <br/>
         <Typography>Expertise</Typography>
         <Select
            defaultValue={expertise}
            closeMenuOnSelect={false}
            options={props.allTopics}
            value={expertise}
            isMulti
            menuPlacement="top"
            onChange={(selectedExpertise) => setExpertise(selectedExpertise)}
         />
         <br/>
         <Typography>Interests</Typography>
         <Select
            defaultValue={interest}
            closeMenuOnSelect={false}
            options={props.allTopics}
            value={interest}
            isMulti
            menuPlacement="top"
            onChange={(selectedInterests) => setInterest(selectedInterests)}
         />
         <br/>
         <Typography>Avatar</Typography>
         <input onChange={(e) => setAvatar(e.target.files[0])} type='file' accept='.png' />
         <Typography style={{ fontSize: '12px', fontStyle: 'italic' }}>Note: It may take several minutes for updated profile photos to appear. Only PNG images are accepted.</Typography>
         <br />
         <Button variant='contained' color='primary' onClick={() => saveProfile()}>Save</Button>
      </CardContent>
   </Card>)
}

function AccountInformation(props) {
   let [saving, setSaving] = useState(false);
   let [password, setPassword] = useState('');
   let [email, setEmail] = useState(props.user.email || '');
   let [newPassword, setNewPassword] = useState('');
   let [emailPassword, setEmailPassword] = useState('');
   let [showPassword, setShowPassword] = useState(false);
   let updatePassword = async () => {
      setSaving(true)
      try {
         await AjaxFunctions.changePassword(password, newPassword);
         ToastAlert.success('Password Updated.');
         setSaving(false);
      } catch (err) {
         ToastAlert.error('Error updating password.');
         setSaving(false)
      }
   }

   let updateEmail = async () => {
      setSaving(true)
      try {
         await AjaxFunctions.changeEmail(emailPassword, email)
         ToastAlert.success('Email Updated.');
         setSaving(false);
      } catch (err) {
         ToastAlert.error('Error updating email.');
         setSaving(false)
      }
   }

   return (<Card style={{ marginBottom: '1em' }}>
      {saving && <LinearProgress />}
      <CardContent>
         <Typography>Current Password</Typography>
         <TextField fullWidth type={showPassword ? 'text' : 'password'} onChange={(e) => setPassword(e.target.value)} variant='outlined' InputProps={{
            endAdornment: <InputAdornment position="end">
               <IconButton className="material-button" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FontAwesomeIcon icon={['far', "eye"]} size={'1x'} /> : <FontAwesomeIcon icon={['far', "eye-slash"]} size={'1x'} />}
               </IconButton>
            </InputAdornment>
         }}
         ></TextField>
         <br />
         <br />
         <Typography>New Password (Must have at least 6 characters)</Typography>
         <TextField fullWidth type={showPassword ? 'text' : 'password'} onChange={(e) => setNewPassword(e.target.value)} variant='outlined' InputProps={{
            endAdornment: <InputAdornment position="end">
               <IconButton className="material-button" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FontAwesomeIcon icon={['far', "eye"]} size={'1x'} /> : <FontAwesomeIcon icon={['far', "eye-slash"]} size={'1x'} />}
               </IconButton>
            </InputAdornment>
         }}
         ></TextField>
         <br/>
         <br/> 
         <Button variant='contained' color='primary' disabled={password == '' || newPassword.length < 6} onClick={() => updatePassword()}>Update Password</Button>
         <hr/>
         <Typography>Current Password</Typography>
         <TextField fullWidth type={showPassword ? 'text' : 'password'} onChange={(e) => setEmailPassword(e.target.value)} variant='outlined' InputProps={{
            endAdornment: <InputAdornment position="end">
               <IconButton className="material-button" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FontAwesomeIcon icon={['far', "eye"]} size={'1x'} /> : <FontAwesomeIcon icon={['far', "eye-slash"]} size={'1x'} />}
               </IconButton>
            </InputAdornment>
         }}
         ></TextField>
         <br />
         <br />
         <Typography>Update Email</Typography>
         <OneLineTextField
            data={email}
            isEditing={true}
            onChange={(e) => setEmail(e.target.value)}
            dataField='bio'
            checkForValidationErrors={false}
            placeholder={'New Email Address'}
            maxLength={100}
         />
         <Button variant='contained' color='primary' disabled={emailPassword.length == 0} onClick={() => updateEmail()}>Update Email</Button>
      </CardContent>
   </Card>)
}

function EmailPreferences(props) {
   let [saving, setSaving] = useState(false);
   let [receiveEmails, setReceiveEmails] = useState(props.user.email || '');

   useEffect(() => {
      async function fetchData() {
         let userReceivesEmails = await AjaxFunctions.checkDoesUserReceiveEmails();
         setReceiveEmails(userReceivesEmails.doesUserReceiveEmails);
       }
       fetchData();
   }, [])

   let updateEmailOptOut = async () => {
      setSaving(true)
      try {
         setReceiveEmails(!receiveEmails)
         await AjaxFunctions.changeEmailOptOut(receiveEmails);
         ToastAlert.success('Email Settings Updated!');
         setSaving(false);
      } catch (err) {
         ToastAlert.error(err.message);
      }
   }
   return (<Card style={{ marginBottom: '1em' }}>
      {saving && <LinearProgress />}
      <CardContent>
         <Typography>Polyplexus E-mails</Typography>
            <div>
               <Checkbox
                  checked={!receiveEmails}
                  onChange={() => {
                     updateEmailOptOut()
                  }}
                  value="checkedB"
                  color="primary"
               />
               Don't send automated emails
            </div>
         
      </CardContent>
   </Card>)
}

function InviteTab(){
   let [saving, setSaving] = useState(false);
   let [email, setEmail] = useState('');

   let updateEmail = async () => {
      setSaving(true)
      try {
         await AjaxFunctions.sendUserInvite(email)
         ToastAlert.success('Invite Sent.');
         setSaving(false);
      } catch (err) {
         ToastAlert.error('Error sending invite.');
         setSaving(false)
      }
   }

   return (<Card style={{ marginBottom: '1em' }}>
      {saving && <LinearProgress />}
      <CardContent>
         <Typography>Invitee Email Address</Typography>
         <OneLineTextField
            data={email}
            isEditing={true}
            onChange={(e) => setEmail(e.target.value)}
            dataField='email'
            checkForValidationErrors={false}
            placeholder={'Email Address'}
            maxLength={100}
         />
         <Button variant='contained' color='primary' disabled={email.length === 0} onClick={() => updateEmail()}>Send Invite</Button>
      </CardContent>
   </Card>)
}

export class EditProfile extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         user: null,
         isSavingDetails: false,
         selectedTab: 0,
      }
   }

   async componentDidMount() {
      let idUser = window.globals.idUser || Utils.getParameterByName('idUser', window.location.href);
      let data = await AjaxFunctions.getProfileData(idUser);
      this.setState({ user: data });
      ReduxStore.store.dispatch(ReduxStore.UserFunctions.setTargetUser(data.userData));
   }
   render() {
      if (!this.state.user) {
         return <LinearProgress />
      }
      let allTopicOptions = this.props.allTopics ? this.props.allTopics.map(topic => ({ value: topic.idTopic, label: topic.name })) : [];
      let expertiseSelection = this.state.user.userData.expertise.map(topic => ({ value: topic.idTopic, label: topic.name }));
      let interestSelection = this.state.user.userData.interest.map(topic => ({ value: topic.idTopic, label: topic.name }))
      return (
         <Grid container spacing={2} >
            <Grid item lg={3}>
               <UserDetails showActionButtons={false} showName={true} />
            </Grid>
            <Grid item lg={9}>
               <Typography style={{ fontWeight: '400', fontSize: '35px', marginBottom: '10px' }}>
                  Edit Profile
            </Typography>
               <Tabs
                  className='userview-tabs'
                  value={this.state.selectedTab}
                  onChange={(event, value) => this.setState({ selectedTab: value })}
                  indicatorColor="primary"
                  textColor="primary"
                  style={{ margin: '15px 0' }}
               >
                  <Tab className='portfolio-list-page-tab-header material-button' label='General Information' />
                  <Tab className='portfolio-list-page-tab-header material-button' label='Account Settings' />
                  <Tab className='portfolio-list-page-tab-header material-button' label='Email Preferences' />
                  <Tab className='portfolio-list-page-tab-header material-button' label='Invite Others' />
               </Tabs>
               {this.state.selectedTab == 0 && <GeneralInformation user={this.state.user.userData} allTopics={allTopicOptions}
                  expertise={expertiseSelection} interests={interestSelection} />}
               {this.state.selectedTab == 1 && <AccountInformation user={this.state.user.userData} />}
               {this.state.selectedTab == 2 && <EmailPreferences user={this.state.user.userData} />}
               {this.state.selectedTab == 3 && <InviteTab user={this.state.user.userData} />}
            </Grid>
         </Grid>
      );
   }
};
